<template>
  <section class="inner" ref="container">
    <div v-if="!readMore" class="bg-content-block" :class="['color-' + data.bg_color]">
      <h2 v-if="data.title" class="block-title" v-html="data.title"></h2>
      <Content v-html="data.content"></Content>
    </div>
    <!-- GREY CONTENT W/READ MORE -->
    <div v-if="readMore && !isDetails" class="grey-content">
      <div v-if="readMoreShowing && order === 0" class="button-wrapper">
        <Button :action="showReadMore" :isButton="true">
          ↓ Read more
        </Button>
      </div>
      <div v-if="!readMoreShowing || (readMoreShowing && order !== 0)"
        class="bg-content-block"
        :class="['color-' + data.bg_color, !readMoreShowing ? 'bg-content-block--top-space' : '']"
      >
        <h2 v-if="data.title" class="block-title" v-html="data.title"></h2>
        <Content v-html="data.content"></Content>
        <div v-if="!readMoreShowing" class="button-wrapper">
          <Button :action="showReadMore" :isButton="true">
            ↑ Close
          </Button>
        </div>
      </div>
    </div>
    <!-- DETAILS CONTENT W/READ MORE -->
    <div v-if="readMore && isDetails" class="details-content" :class="readMoreShowing ? '' : 'details-content--open'">
      <div class="bg-content-block" :class="['color-' + data.bg_color]">
        <h2 v-if="data.title" class="block-title" v-html="data.title"></h2>
        <Content v-html="data.content"></Content>
        <div v-if="isDetailsLong" class="button-wrapper">
          <Button :action="showReadMore" :isButton="true">
            {{ readMoreShowing ? '↓ More info' : '↑ Hide info'}}
          </Button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Content from '@/components/ui/Content.vue';
  import Button from '@/components/ui/Button.vue';

  export default {
    name: 'bg-content-block',

    data() {
      return {
        isDetails: false,
        isDetailsLong: false,
        readMoreShowing: true,
      }
    },

    props: {
      data: Object,
      order: Number,
      readMore: {
        type: Boolean,
        default: false
      }
    },

    components: {
      Content,
      Button
    },

    mounted() {
      console.log(this.order)

      if(this.data.bg_color !== "gray") {
        const contentLenght = this.data.content.split('</p>').filter(item => item !== "\n");

        if(contentLenght.length > 5) {
          this.isDetailsLong = true
        }

        return this.isDetails = true
      }
    },

    methods: {
      showReadMore() {
        if(this.readMoreShowing) {
          this.readMoreShowing = false;
        } else {
          this.readMoreShowing = true;
        }

        window.scroll(0, this.$refs.container.offsetTop - 90);
      }
    }
  }
</script>

<style lang="scss">
  .grey-content,
  .details-content {
    & > .button-wrapper {
      padding-top: clamp(1.875em, 2.309vw + 1.277em, 3.125em);
      padding-bottom: clamp(2.5em, 3.464vw + 1.604em, 4.375em);
    }

    & .bg-content-block .button-wrapper {
      padding-bottom: 12px;
    }

    .button-wrapper {
      font-size: 16px;

      button {
        display: block;
        font-size: 21px;
        margin: 0 auto;
      }
    }

    .bg-content-block {
      max-width: calc(100% - 24rem);
      padding: 0 0 var(--padding);
      margin: 0 auto;

      &.bg-content-block--top-space {
        margin-top: clamp(1.875em, 2.309vw + 1.277em, 3.125em)
      }

      &.color-green {
        background: var(--footer-3);
        & .ui-enter {
          background: transparent;
        }
      }

      &.color-gray {
        background: var(--light-gray);
        & .ui-enter {
          background: transparent;
        }
      }
    }
  }

  .grey-content .bg-content-block {
    margin-bottom: clamp(2.5em, 3.464vw + 1.604em, 4.375em);
  }

  .details-content {
    margin-bottom: clamp(1.875em, 2.309vw + 1.277em, 3.125em);

    & p {
      display: none;
    }

    & p:nth-child(-n+5) {
      display: block;
    }

    &.details-content--open p {
      display: block;
    }
  }


  .bg-content-block {
    padding: 0 12rem var(--padding);
    // margin-bottom: var(--padding-x2);

    h2:first-child,
    h3:first-child {
      margin-top: 0;
    }

    .block-title {
      padding: 0 0 var(--padding);
      font-size: var(--medium-size);
      line-height: 1;
    }

    &.color-green .ui-enter {
      background: var(--footer-3);
      padding: var(--padding) var(--padding);
      p {
        padding-left: 1.85rem;
        text-indent: -1.85rem;
      }
      p:last-child {
        margin-bottom: 0;
      }
    }

    &.color-gray .ui-enter {
      background: var(--light-gray);
      padding: var(--padding) var(--padding);
      p:last-child {
        margin-bottom: 0;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .details-content,
    .grey-content {
      .bg-content-block {
        max-width: 100%;
        padding: var(--padding) 0;
      }
    }

    .bg-content-block {
      padding: var(--padding) 0;

      &.color-green .ui-enter {
        p {
          text-indent: -6rem;
          padding-left: 6rem;
        }
      }
    }
  }
</style>
